export default __webpack_public_path__ + "static/media/0052.b421af1a.png";